<template>
  <v-col cols="12" md="8">
    <v-card-text>
      <v-row dense>
        
        <v-col cols="12">
          <v-text-field color="primary" label="Title" v-model="form.title"></v-text-field>
        </v-col>
        
        <v-col cols="12">
          <span class="subtitle-2">Message</span>
        </v-col>
        
        <v-col cols="12">
          <v-textarea placeholder="Enter your message here..." outlined height="300"
            :style="{ borderRadius: '15px' }" v-model="form.body"></v-textarea>
        </v-col>
        
        <v-col cols="12">
          <div class="d-flex justify-space-between align-center">
            <div class="flex-grow-1"></div>

            <v-btn depressed color="#258BF5" large class="mr-3"
              :dark="!shouldSendToAll"
              :style="{ borderRadius: '12px' }"
              :loading="isSaveDraftStart"
              :disabled="shouldSendToAll"
              @click="saveDraft">
              Save as draft
            </v-btn>
            
            <div class="d-flex align-center">
              <v-btn depressed color="#1665CE" large
                :dark="!!isSendNotificationFormValid || isSendNotificationStart"
                :style="{ borderRadius: '12px' }"
                :class="`text-capitalize ${isSendNotificationFormValid ? 'white--text' : ''}`"
                @click="sendNotification"
                :loading="isSendNotificationStart"
                :disabled="!isSendNotificationFormValid">
                Send
              </v-btn>
            </div>
            
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-col>
</template>

<script>

const defaultForm = {
  id: null,
  title: null,
  date: null,
  time: null,
  body: null,
  isButton: false,
  buttonName: null,
  linkName: null,
};

import { CREATE_NOTIFICATION, GET_NOTIFICATION_RECIPIENTS } from "@/views/csr/store/typeDefs/notification";

export default {
  name: 'Compose',
  props: ['shouldSendToAll', 'selectedRecipientsID', 'isNotificationSnackbarOpen'],
  data() {
    return {
      form: Object.assign({}, defaultForm),
      defaultForm,
      isSendNotificationStart: false,
      isSaveDraftStart: false,
    }
  },
  computed: {
    isSendNotificationFormValid() {
      const { title, body } = this.form;
      if (this.shouldSendToAll) {
        return title && body;
      }
      return this.selectedRecipientsID.length > 0 && title && body;
    }
  },
  methods: {
    async sendNotification() {
      const payload = {
        id: this.form.id || null,
        title: this.form.title || null,
        body: this.form.body || null,
        time: this.form.time || null,
        date: this.form.date || null,
        recipients: this.selectedRecipientsID,
        type: "sent",
      };


      console.log(payload);

      if (this.shouldSendToAll) {
        await this.sendToAll();
        return;
      }
      this.isSendNotificationStart = true;
      const { success } = await this.$store.dispatch(
        CREATE_NOTIFICATION,
        payload
      );
      let snackBarOptions;
      if (success) {
        this.isSendNotificationStart = false;
        this.form = Object.assign({}, this.defaultForm);
        snackBarOptions = {
          content: Object.assign({}, { color: "success", message: "Notification Sent!"  }),
          display: true,
          type: 'sent'
        }
        this.$emit('clearReceipients');
      } else {
        snackBarOptions = {
          content: Object.assign({}, { color: "error", message: "Something went wrong!"  }),
          display: true,
          type: 'error'
        }
      }
      this.$emit('openSnackbar', snackBarOptions);
      this.isSendNotificationStart = false;
    },
    async saveDraft() {
      const payload = {
        title: this.form.title || null,
        body: this.form.body || null,
        time: this.form.time || null,
        date: this.form.date || null,
        recipients: this.selectedRecipientsID,
        type: "draft",
      };

      this.isSaveDraftStart = true;
      const { success } = await this.$store.dispatch(
        CREATE_NOTIFICATION,
        payload
      );
      
      let snackBarOptions = {}
      if (success) {
        this.isSaveDraftStart = false;
        this.form = Object.assign({}, this.defaultForm);
        this.$emit('clearReceipients');
        
        snackBarOptions = {
          content: Object.assign({}, { color: "success", message: "Draft Saved!" }),
          display: true,
          type: 'draft'
        }

      } else {
        snackBarOptions = {
          content: Object.assign({},{ color: "error", message: "Something went wrong!" }),
          display: true, 
          type: 'draft'
        }
      }

      this.$emit('openSnackbar', snackBarOptions);
      
      this.isSaveDraftStart = false;
    },
    async sendToAll() {
      this.isSendToAllStart = true;
      let page = 1;
      let recipients = await this.$store.dispatch(GET_NOTIFICATION_RECIPIENTS, {
        search: null,
        page,
      });

      this.$emit('sendToAllStarted', {
        value: true
      });

      while (recipients.length > 0) {
        for (let index = 0; index < recipients.length; index++) {
          const payload = {
            id: this.form.id || null,
            title: this.form.title || null,
            body: this.form.body || null,
            time: this.form.time || null,
            date: this.form.date || null,
            recipients: [recipients[index].id],
            type: "sent",
          };
          const { success } = await this.$store.dispatch(
            CREATE_NOTIFICATION,
            payload
          );
          if (!success) {
            this.notificationSnackbarOptions = Object.assign(
              {},
              { color: "error", message: "Something went wrong!" }
            );
            break;
          }
        }
        page = page + 1;
        recipients = await this.$store.dispatch(GET_NOTIFICATION_RECIPIENTS, {
          search: null,
          page,
        });
      }
      this.form = Object.assign({}, this.defaultForm);
      this.selectedRecipientsID = [];
      this.shouldSendToAll = false;
      this.isSendToAllStart = false;
      this.notificationSnackbarOptions = Object.assign(
        {},
        { color: "success", message: "Send to all done!" }
      );
      this.isNotificationSnackbarOpen = true;
      this.$emit('sendToAllStarted', {
        value: false
      });
    },
    prefillForm (params) {
      console.log(params)
      this.form = Object.assign({}, params.form);
    }
  }

}
</script>